import type { ReactNode } from 'react';

/**
 * Reading layout for Learn + legal docs: prose capped at 680px.
 *
 * At `xl`, equal flexible gutters keep the reading column optically centered
 * while the optional sticky TOC occupies the left gutter. At smaller widths the
 * TOC is hidden and the reading column remains centered without squeezing it.
 */
export function ArticleReadingLayout({ toc, children }: { toc?: ReactNode; children: ReactNode }) {
  return (
    <div className="col-span-9 xl:grid xl:grid-cols-[minmax(0,1fr)_minmax(0,680px)_minmax(0,1fr)] xl:gap-10">
      {toc ? (
        <aside className="hidden min-w-0 xl:col-start-1 xl:block xl:pr-4">
          <div className="learn-article-toc sticky top-24 max-h-[calc(100vh-8rem)] overflow-y-auto overscroll-y-contain pr-4">
            {toc}
          </div>
        </aside>
      ) : null}
      <div className="mx-auto w-full max-w-[680px] xl:col-start-2 xl:row-start-1">{children}</div>
    </div>
  );
}
